import React, { useMemo, useState } from "react";
import { DOCUMENT_CONTENT_TYPE_PDF } from "../../../../../app/constants";
import { convertFileDataForUrl } from "../../../../../app/documentUploadUtils";
import { humanReadableDate, licenceSubTypeString } from "../../../../../app/utils";
import DocumentViewer from "../../../../../components/DocumentViewer/DocumentViewer";
import { 
    BackButton,
    LineSeperator,
    NavigationLinkButton 
} from "../../../../../components/RegularComponents";
import { InformationDetailPanelSection } from '../../InformationDetailPanelSection';
import { fetchBusinessLicnecePDF } from "../../../../../redux/slice/bltDecisionSlice";

export const CollectorDetails = (props) => {
    const { collector, setCollector } = props;
    const handleGoBack = () => {
        setCollector()
    }

    const [openDocumentViewer, setOpenDocumentViewer] = useState(false);
    const [documentViewerDocument, setDocumentViewerDocument] = useState(null);
    const [selectedFile, setSelectedFile] = useState(null);

    const getApplicationLicencePDF = async (applicationId) => {
        const pdf = await fetchBusinessLicnecePDF(applicationId);
        let fileDataUrl = convertFileDataForUrl(
          pdf.file,
          DOCUMENT_CONTENT_TYPE_PDF
        );
        setDocumentViewerDocument(fileDataUrl);
        setSelectedFile(pdf);
        setOpenDocumentViewer(true);
      };
      
    const detailRows = useMemo(() => {
        const personData = collector.businessLicenceData.personData
        return [
            {
                title: "Licence Type",
                value: (<span>{licenceSubTypeString(collector.licencingSubType)}</span>)
            },
            {
                title: "Licence number",
                value: collector.licenceNumber
            },
            {
                title: "Licence PDF",
                value: (<NavigationLinkButton 
                            style={{marginLeft: "-6px"}}
                            text={collector.contactName} 
                            onClick={() => {
                                // send PDF request
                                let id = collector.id
                                
                                // if originalApplicationId field is available 
                                // and its set to a valid value, then this application
                                // is from archive table. We need to fetch the 
                                // pdf for the originalApplicationId.
                                if(collector.originalApplicationId) {
                                    id = collector.originalApplicationId
                                }

                                getApplicationLicencePDF(id)
                            }}
                        />)
            },
            {
                title: "Name",
                value: (<span>{collector.contactName}</span>)
            },
            {
                title: "Home address",
                value: (<span>{personData.addressData?.address1}, {personData.addressData?.cityName}, {personData.addressData?.stateName}, {personData.addressData.postalCode} </span>)
            },
            {
                title: "Phone",
                value: (<span>{personData.phoneNumber}</span>)
            },
            {
                title: "Last updated",
                value: (<span>{humanReadableDate(collector.submittedDate)}</span>)
            },
        ]
    }, [collector])

    return (
        <div className="licence-application-details-panel">
            <BackButton onClick={handleGoBack} />
            <div className="licence-application-details-panel">
                {detailRows.map((detailRow, i) => (
                    <div key={i}>
                        <InformationDetailPanelSection 
                            header={detailRow["title"]} 
                            value={detailRow["value"]}
                        />
                        <LineSeperator />
                    </div>
                ))}
            </div>
            <DocumentViewer
                fileData={documentViewerDocument}
                isOpen={openDocumentViewer}
                fileName={selectedFile?.filename}
                handleClose={() => setOpenDocumentViewer(false)}
            />
        </div>
    )
}

// const DetailSection = ({ data }) => {
//     return (
//         <>
//         <div className="row section-row-margin">
//             <div className="collector-licence-col col-md-4" style={{ flexGrow: 1, display: "flex", fontWeight: "bold" }}>
//                 <span>{data.title}</span>
//             </div>

//             <div className="collector-licence-col col-md-8" style={{ display: "flex" }}>
//                 {data.value}
//             </div>
//         </div>
//         </>
//     )
// }